import React from 'react';
import { Grid } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { useGlobal } from '../../../contexts/Global/context';

import Icon from '../../Icons';

import * as S from './styles';

function LinkCard({ link, title, desc, icons }) {
    const { contrastTheme } = useGlobal();

    return (
        <S.LinkCardContainer>
            <Link to={link}>
                <S.ButtomCard>
                    <Grid container direction="row" justifyContent="center" alignItems="center">
                        {icons?.left?.name && (
                            <Grid item xs={2}>
                                <Icon
                                    name={icons?.left?.name}
                                    type={icons?.left?.type}
                                    size={36}
                                    color={contrastTheme ? '#FFF333' : '#EC6E0C'}
                                />
                            </Grid>
                        )}
                        <Grid item xs={8}>
                            <S.Title>{title}</S.Title>
                            <S.Desc>{desc}</S.Desc>
                        </Grid>
                        <Icon
                            name={icons?.right?.name || 'ArrowRight'}
                            type={icons?.right?.type}
                            color={contrastTheme ? '#FFF333' : '#EC6E0C'}
                        />
                    </Grid>
                </S.ButtomCard>
            </Link>
        </S.LinkCardContainer>
    );
}

export default LinkCard;
